import * as _ from "lodash-es";

export default {
  namespaced: true,
  state: {
    notificatoinsMap: {},
    isAllNotificationsLoaded: false,
    isNotificationsLoading: false,
  },
  mutations: {
    addNotifications(state, notifications) {
      state.notificatoinsMap = {
        ...state.notificatoinsMap,
        ..._.keyBy(notifications, "id"),
      };
    },
    setNotificationsLoading(state, isLoading) {
      state.isNotificationsLoading = isLoading;
    },
    setAllNotificationsLoaded(state, isLoaded) {
      state.isAllNotificationsLoaded = isLoaded;
    },
  },
  getters: {
    unreadNotificationsMap(state) {
      return _.pickBy(state.notificatoinsMap, (notification) => !notification.is_read);
    },
  },
};
